import { isPlaybookDisabled } from '@ion/api';

/**
 * Helper to flatten playbook staged revisions for table display.
 * @param {Object[]} playbooks - Array of playbooks from useQueryIntPlaybooksWithRevs
 * @returns {Object[]}
 */
function formatPlaybooksForTable(playbooks) {
  if (!Array.isArray(playbooks)) {
    return [];
  }

  const disabledRevisions = new Set(playbooks.filter(isPlaybookDisabled).map(playbook => playbook.revision));

  return playbooks.flatMap(playbook => {
    if (!Array.isArray(playbook.staged_revisions)) {
      return [];
    }

    return playbook.staged_revisions.map(stagedRevision => {
      const {
        id,
        stagedForDelete,
        pipeline_integration: { pipeline, deployed_revision, disabled },
      } = stagedRevision;

      return {
        id,
        pipelineName: pipeline.name,
        clusterName: pipeline.cluster.name,
        playbookRevision: playbook.revision,
        playbookRevisionDisabled: isPlaybookDisabled(playbook),
        playbookStagedForDelete: Boolean(stagedForDelete),
        deployedRevision: deployed_revision,
        deployedRevisionDisabled: disabledRevisions.has(deployed_revision),
        disabled,
      };
    });
  });
}

export default formatPlaybooksForTable;
